import React from 'react';
import inflection from 'inflection';
import classnames from 'classnames/bind';

import styles from './employerAssociationStyles';

import Link from 'buyside/components/presentation/Link/link';

import { profileSearchUrl, employerProfileUrl } from 'buyside/util/urlHelper';

const cx = classnames.bind(styles);

const EmployerAssociation = ({ mostRecentEmployer, style = null }) => {
  if (!mostRecentEmployer) return null;
  const { currentEmployer, title, employer } = mostRecentEmployer;
  if (!employer) return null;
  const employerId = employer.id;
  const employerName = employer.name;
  const employerUrl = employerId
    ? employerProfileUrl(employerId)
    : profileSearchUrl({ employer: employerName });
  const employerLink = <Link to={employerUrl}>{employerName}</Link>;
  const displayTitle = inflection.titleize(title && title !== 'other' ? title : '');

  return (
    <div className={cx(styles.userEmployment, style)}>
      {!currentEmployer && 'Formerly '}
      {displayTitle}
      {(displayTitle || !currentEmployer) && ' at '}
      {employerLink}
    </div>
  );
};

export default EmployerAssociation;
